"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMemoryStorage = exports.useLocalStorage = exports.useSessionStorage = void 0;
const events_1 = __importDefault(require("events"));
const react_1 = require("react");
// forceDefaultがtrueの場合はstorageから取得せず、defaultValueを返す
// 変更された時に、storageに反映させる。
const createStorageHook = (storage) => {
    const emitter = new events_1.default();
    return (key, defaultValue, forceDefault) => {
        const [value, setValue] = (0, react_1.useState)(() => {
            if (!forceDefault) {
                const value = storage === null || storage === void 0 ? void 0 : storage.getItem(key);
                if (value) {
                    return JSON.parse(value);
                }
            }
            return defaultValue;
        });
        const set = (value) => {
            storage === null || storage === void 0 ? void 0 : storage.setItem(key, JSON.stringify(value));
            emitter.emit(key, value);
        };
        // handle update of this session (only this tab)
        (0, react_1.useEffect)(() => {
            const handler = (value) => {
                setValue(value);
            };
            emitter.on(key, handler);
            return () => {
                emitter.off(key, handler);
            };
        });
        // handle update of other sessions (other tabs)
        storage &&
            (0, react_1.useEffect)(() => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const handler = (e) => {
                    if (e.key === key && e.storageArea === storage) {
                        setValue(e.newValue ? JSON.parse(e.newValue) : undefined);
                    }
                };
                addEventListener("storage", handler);
                return () => {
                    removeEventListener("storage", handler);
                };
            });
        return [value, set];
    };
};
exports.useSessionStorage = createStorageHook(sessionStorage);
exports.useLocalStorage = createStorageHook(localStorage);
exports.useMemoryStorage = createStorageHook();
